
import { errManager, showNotification } from '@/core/config/Tools';
import GlobalService from '@/core/services/GlobalService';
import { defineComponent, onMounted, ref } from 'vue';
import { useI18n } from "vue-i18n/index";
import moment from 'moment';
//components
import ModalTraslado from '../modals/ModalTraslado.vue';

export default defineComponent({
    props: {
        rowItem: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },
    components:{ ModalTraslado },
    setup(props) {
        const { t } = useI18n();
        const drawerOption = ref(false);
        const loader = ref(false);
        const loaderPhoto = ref(false);
        const listPayroll = ref<Array<any>>([]);
        const REPO = ref(process.env.VUE_APP_REPO);
        const photo = ref<any>({});
        const ModalTrasladoRef = ref<any>(null);
        const itemPayroll = ref<any>({});

        const openDrawer = () => {
            drawerOption.value = true;
        };

         const getPhoto = async () => {
            loaderPhoto.value = true;
            GlobalService.post('photo', {idperson: props?.rowItem?.idperson})
                .then((res) => {
                    loaderPhoto.value = false
                    photo.value = res.data
                }).catch(({ response }) => {
                    loaderPhoto.value = false;
                    errManager(response);
                }).finally(()=>{
                    loaderPhoto.value = false;
                })
        }

        const getData= async() => {
            loader.value = true;
            await GlobalService.get('api/person', `${props.rowItem.idperson}/payroll`)
            .then((res) => {
                loader.value = false;
                listPayroll.value = res.data;
            }).catch(({ response })=>{
                loader.value = false;
                errManager(response);
            }).catch(()=>{
                loader.value = false;
            });
        };

        const handlerToRelease = async(row: any, check) => {
            loader.value = true;
            await GlobalService.update('person', `payroll/${row.idpayroll}`, 'release', {idacrd: row.idpayroll, checkdoc: check})
            .then((res)=>{
                loader.value = false;
                showNotification(res.data);
                if(res.data.status == 'success'){
                    getData();
                }
            }).catch(({ response })=>{
                loader.value = false;
                errManager(response);
            }).finally(()=>{
                loader.value = false;
            });
        };

        const onOpened = async () => {
            getPhoto();
            getData();
        };

        const onClosed = () => {
            photo.value = {};
            listPayroll.value = [];
        };

        const oPenModalTraslado = (row: any) => {
            if(ModalTrasladoRef.value){
                itemPayroll.value = row;
                ModalTrasladoRef.value.openModal();
            }
        }
        
        return {
            t,
            REPO,
            loader,
            loaderPhoto,
            drawerOption,
            listPayroll,
            moment,
            photo,
            ModalTrasladoRef,
            itemPayroll,
            //events
            openDrawer,
            onOpened,
            onClosed,
            getData,
            handlerToRelease,
            oPenModalTraslado
        }
    },
})
